import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AnimationObserver.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/tailwind.css");
